import React from 'react';
import TabBar from 'shared/components/TabBar/TabBar';

function TabsLayout() {
  return <TabBar />;
}

export default TabsLayout;
